import { gql } from '@apollo/client';

export const GET_UPGRADE_PATHS_QUERY = gql`
  query GetUpgradePaths {
    user {
      id
      customer {
        email
      }
      upgradePaths {
        bundle
        license_class
        license_type
        licensedproduct_id
        registered
        title
        upgrade_path {
          license_type
          licensedproduct_id
          title
        }
      }
    }
  }
`;

export const GET_BASE_PRODUCTS_MESSAGES = gql`
  query GetBaseProductsMessages($languages: [String], $sku: String!) {
    content {
      required_base_products(filter: { sku: { _eq: $sku } }) {
        sku
        messages(filter: { languages_code: { code: { _in: $languages } } }) {
          id
          required_base_products
          languages_code {
            code
          }
        }
      }
    }
  }
`;
